import React from 'react'
import Navabar from '../Component/Navabar'
import Footer from '../Component/Footer'
import Faqcomponet from '../Component/Faqcomponet'

export default function Faq() {
  return (
    <div className='w-screen h-[1150px]  bg-[#168356]'>
        <Navabar/>
        <div className="  [font-family:'Inter-Bold',Helvetica] font-bold text-white text-[60px] sm:text-[40px] tracking-[-0.90px] leading-[73.7px] whitespace-nowrap text-center">
        FAQ
      </div>
        <div className=" w-[1340px] h-[745px]  sm:h-[700px] my:w-[1200px] ipad:w-[690px] sm:w-[330px]  mt-[69px] ipad:mt-[40px] sm:mt-[20px] ml-[41px] mr-[50px] bg-[#1a492780] rounded-[25px]" >
       <Faqcomponet 
       paragraph=" Meet Liam: Your Digital Agronomy Collaborator?"
       discription="  Meet Liam: Your Digital Agronomy Collaborator, Boost The Efficacy Of Your Field Productivity, And Bring New 
       Ideas To Uncover Yield Potential."
       />
       <div className='my:w-[1200px] w-[1340px] ipad:w-[690px] sm:w-[330px] mt-[27px] h-px border border-neutral-400  border-opacity-50'></div>
        <Faqcomponet 
       paragraph=" Meet Liam: Your Digital Agronomy Collaborator?"
       discription="  Meet Liam: Your Digital Agronomy Collaborator, Boost The Efficacy Of Your Field Productivity, And Bring New 
       Ideas To Uncover Yield Potential."
       />
         <div className='my:w-[1200px] w-[1340px] ipad:w-[690px] sm:w-[330px] mt-[27px] h-px border border-neutral-400  border-opacity-50'></div>
         <Faqcomponet 
       paragraph=" Meet Liam: Your Digital Agronomy Collaborator?"
       discription="  Meet Liam: Your Digital Agronomy Collaborator, Boost The Efficacy Of Your Field Productivity, And Bring New 
       Ideas To Uncover Yield Potential."
       />
         <div className='my:w-[1200px] w-[1340px] ipad:w-[690px] sm:w-[330px] mt-[27px] h-px border border-neutral-400  border-opacity-50'></div>
         <Faqcomponet 
       paragraph=" Meet Liam: Your Digital Agronomy Collaborator?"
       discription="  Meet Liam: Your Digital Agronomy Collaborator, Boost The Efficacy Of Your Field Productivity, And Bring New 
       Ideas To Uncover Yield Potential."
       />
         <div className='my:w-[1200px] w-[1340px] ipad:w-[690px] sm:w-[330px] mt-[27px] h-px border border-neutral-400  border-opacity-50'></div>
         <Faqcomponet 
       paragraph=" Meet Liam: Your Digital Agronomy Collaborator?"
       discription="  Meet Liam: Your Digital Agronomy Collaborator, Boost The Efficacy Of Your Field Productivity, And Bring New 
       Ideas To Uncover Yield Potential."
       />
         <div className='my:w-[1200px] w-[1340px] ipad:w-[690px] sm:w-[330px] mt-[27px] h-px border border-neutral-400  border-opacity-50'></div>
         <Faqcomponet 
       paragraph=" Meet Liam: Your Digital Agronomy Collaborator?"
       discription="  Meet Liam: Your Digital Agronomy Collaborator, Boost The Efficacy Of Your Field Productivity, And Bring New 
       Ideas To Uncover Yield Potential."
       />
         <div className='my:w-[1200px] w-[1340px] ipad:w-[690px] sm:w-[330px] mt-[27px] h-px border border-neutral-400  border-opacity-50'></div>
         <Faqcomponet 
       paragraph=" Meet Liam: Your Digital Agronomy Collaborator?"
       discription="  Meet Liam: Your Digital Agronomy Collaborator, Boost The Efficacy Of Your Field Productivity, And Bring New 
       Ideas To Uncover Yield Potential."
       />
         <div className='my:w-[1200px] w-[1340px] ipad:w-[690px] sm:w-[330px] mt-[27px] h-px border border-neutral-400  border-opacity-50'></div>
         <Faqcomponet 
       paragraph=" Meet Liam: Your Digital Agronomy Collaborator?"
       discription="  Meet Liam: Your Digital Agronomy Collaborator, Boost The Efficacy Of Your Field Productivity, And Bring New 
       Ideas To Uncover Yield Potential."
       />
         <div className='my:w-[1200px] w-[1330px] ipad:w-0 sm:w-0 mt-[27px] h-px border border-neutral-400  border-opacity-50'></div>

        </div>
        <Footer/>

    </div>
  )
}
